module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container work-container",
    class: _vm.viewMode
  }, [_c('article', {
    staticClass: "work detail-content"
  }, [_c('div', {
    staticClass: "fixed-container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon-cancel",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.hideFull()
      }
    }
  })])]), _vm._v(" "), _c('v-touch', {
    staticClass: "swipe-back",
    attrs: {
      "tag": "div"
    },
    on: {
      "swipedown": _vm.hideFull
    }
  }), _vm._v(" "), (_vm.fullNode.show_topimg) ? _c('vue-slideshow', {
    attrs: {
      "images": _vm.fullNode.images,
      "fullSizes": _vm.fixedSizes,
      "defaultSize": "scale_crop_1024_461",
      "speed": 0
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.fullNode.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('time', {
    staticClass: "date",
    attrs: {
      "title": _vm.fullNode.date
    }
  }, [_vm._v(_vm._s(_vm._f("toYear")(_vm.fullNode.date)))]), _vm._v(" "), (_vm.fullNode.client_name.length > 0) ? _c('h5', {
    staticClass: "client-name"
  }, [_vm._v(_vm._s(_vm.fullNode.client_name))]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.fullNode.category))])]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.fullNode.body)
    }
  }), _vm._v(" "), (_vm.fullNode.hasSections) ? _c('paragraphs', {
    attrs: {
      "sections": _vm.fullNode.sections,
      "sizes": _vm.allSizes,
      "nid": _vm.fullNode.nid
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "projects main-content"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showFilters) ? _c('ul', {
    staticClass: "slide-filter horizontal"
  }, _vm._l((_vm.filters), function(name, key) {
    return _c('li', {
      class: {
        key: true, 'active': key === _vm.filter
      },
      on: {
        "click": function($event) {
          _vm.filterSlides(key)
        }
      }
    }, [_vm._v(_vm._s(name))])
  })) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "projects-list listing",
    class: {
      'images-loaded': _vm.imgsLoaded
    }
  }, _vm._l((_vm.slides), function(slide, si) {
    return _c('li', {
      key: slide.nid,
      class: slide.classes,
      attrs: {
        "data-index": si,
        "data-path": slide.path,
        "data-nid": slide.nid
      }
    }, [_c('figure', {
      staticClass: "preview",
      attrs: {
        "data-num": slide.images.length
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showFullNode(slide)
        }
      }
    }, [_vm._l((slide.images), function(img, index) {
      return [(index < 1) ? [_c('img', {
        attrs: {
          "src": img.sizes[_vm.fixedSize],
          "width": img.attributes.width,
          "height": img.attributes.height
        }
      })] : _vm._e()]
    }), _vm._v(" "), _c('figcaption', [_c('div', {
      staticClass: "inner"
    }, [_c('h4', {
      attrs: {
        "title": slide.category
      }
    }, [_vm._v(_vm._s(slide.title))])])])], 2)])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ffc2068"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 46
// module chunks = 0